import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const dropIcon = require("./../assets/img/drop-icon.svg").default;
const removeIcon = require("./../assets/img/remove-icon.svg").default;
const viewIcon = require("./../assets/img/eye-icon.svg").default;
const previewImg = require("./../assets/img/No-Preview-Available.svg").default;

const UploadFiles = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileDetails, setFileDetails] = useState(null);
  const [fileData, setFileData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [fileId, setFileID] = useState(null);
  const [fileIndex, setFileIndex] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [validationStatus, setValidationStatus] = useState("");

  const handleFileDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0]; // Get the first file

    if (file) {
      uploadFiles([file]);
    } else {
    }
  };

  const handleFileInputChange = (event) => {
    const files = event.target.files;
    uploadFiles(files);
  };

  const uploadFiles = async (files) => {
    // const fileArray = Array.from(files);
    const formData = new FormData();

    const allowedExtensions = ["xlsx"]; // List of allowed extensions
    const fileArray = Array.from(files).filter((file) => {
      const extension = file.name.split(".").pop().toLowerCase();
      return allowedExtensions.includes(extension);
    });
    if (fileArray.length === 0) {
      console.error("No valid files to upload.");
      setValidationStatus("No valid files to upload.");
      return;
    }
    setValidationStatus();
    // Convert files to Base64 and append to uploadExcel parameter
    const fileDataArray = await Promise.all(
      fileArray.map(async (file) => {
        const base64Data = await getBase64Data(file); // Function to convert file to Base64
        return {
          name: file.name,
          size: file.size,
          data: base64Data,
        };
      })
    );

    formData.append("user_id", userData ? userData.id : "");
    formData.append("uploadExcel", JSON.stringify(fileDataArray));

    try {
      const response = await fetch(
        "https://cliqestimatebuilder.com/waiver_admin/files",
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setFileDetails(data.data.uploaded_data);
          setFileID(data.data.id);
          setUploadedFiles((prevUploadedFiles) => [
            ...prevUploadedFiles,
            ...fileDataArray,
          ]);
        });
    } catch (error) {
      // Handle error if needed
      console.error("Error during file upload:", error);
    }
  };

  const getBase64Data = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleRemoveClick = (index, fileId) => {
    setFileIndex(fileId);
    setShowConfirmationModal(true);
  };

  const handleDelete = () => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    const formData = new FormData();
    formData.append("id", fileId);

    fetch(`https://cliqestimatebuilder.com/waiver_admin/files/${fileId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.res == 1) {
          // Update the file list by removing the file at the specified index

          const updatedFiles = [...uploadedFiles];
          updatedFiles.splice(fileIndex, 1);
          setUploadedFiles(updatedFiles);
          setShowConfirmationModal(false);
          setFileDetails(null);
        } else {
          if (data.error) {
            console.error("Error deleting file:", data.error);
            // Handle the error condition if required
          } else {
            console.error("Error deleting file: Unknown error");
            // Handle other types of errors
          }
        }
      })
      .catch((error) => console.error("Error changing delete status:", error));
  };

  useEffect(() => {
    // Retrieve user data from local storage
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);

    // Fetch file data from the API
    // fetch("https://cliqestimatebuilder.com/waiver_admin/files", {
    //   headers: {
    //     Authorization: `Bearer ${storedUserData.token}`,
    //   },
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     if (data.data && Array.isArray(data.data.uploaded_data)) {
    //       setFileData(data.data.uploaded_data);
    //     } else {
    //       console.error("Received data is not in the expected format:", data);
    //     }
    //   })
    //   .catch((error) => console.error("Error fetching file data:", error));
  }, []);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="uploadLft">
            <div className="dropDiv">
              <div
                className="drop-area"
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleFileDrop}
              >
                <img src={dropIcon} alt="image" />
                <h3>Drag and drop your file here</h3>
                <p>
                  Choose a file to import your data. All .xlsx is supported.
                </p>
                <h4>OR</h4>
                <label className="browse-btn">
                  Browse
                  <input type="file" onChange={handleFileInputChange} />
                </label>
              </div>
              <span className="lgnStatus mrhnTp">{validationStatus}</span>
            </div>

            <div className="recentDiv upRcnt">
              {uploadedFiles.length > 0 && (
                <div className="file-list">
                  <h2>Recently added file</h2>
                  <ul>
                    {uploadedFiles.map((file, index) => (
                      <li key={index}>
                        <div className="fileName">{file.name}</div>
                        <div className="fileSize">({file.size} bytes)</div>
                        <div className="addedBtns">
                          <button onClick={() => handleRemoveClick(file?.id)}>
                            <img src={removeIcon} alt="image" />
                          </button>
                          <Link
                            to={{
                              pathname: `/view-one-file/${fileId}`,
                              state: { fileData: file },
                            }}
                          >
                            <img src={viewIcon} alt="View" />
                          </Link>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {showConfirmationModal && (
              <div className="confirmation-modal">
                <div className="modal-content">
                  <p>Are you sure you want to remove this file?</p>
                  <div className="modal-buttons">
                    <button onClick={() => handleDelete()}>Yes</button>
                    <button onClick={() => setShowConfirmationModal(false)}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="uploadRgt">
            <h2>Preview</h2>
            <div className="previewDiv">
              <ul>
                <div className="prevImgRgt">
                  {!fileDetails && <img src={previewImg} alt="image" />}
                </div>
                {fileDetails &&
                  fileDetails[0] &&
                  Object.entries(fileDetails[0]).map(([label, value]) => (
                    <li key={label}>
                      <label>{value}:</label>
                      <div className="dscFile">{fileDetails[1][label]}</div>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadFiles;
